var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.groupedComments),function(group,index){return _c('div',{key:("group" + index)},_vm._l((group),function(comment){return _c('FocusComment',_vm._b({key:comment.id},'FocusComment',comment,false))}),1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b01ee78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Focus/FocusComments.vue
// module id = Ykfz
// module chunks = 1